export default __webpack_public_path__ + "static/media/Parallax-HUD-02.3fda2cf1.jpg";